import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function SendFillIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="m16.303 20.97 5.62-17c.388-1.17-.724-2.281-1.894-1.894L3.03 7.696c-1.332.44-1.384 2.308-.077 2.82l3.658 1.438a3 3 0 0 0 2.662-.233l4.198-2.567c.896-.548 1.922.48 1.375 1.375l-2.567 4.198a3 3 0 0 0-.233 2.662l1.437 3.658c.513 1.307 2.38 1.255 2.82-.077" />
    </Icon>
  );
}

SendFillIcon.displayName = 'SendFillIcon';
